// noinspection TypeScriptValidateTypes

import {createI18n} from "vue-i18n";
import messages from '@intlify/unplugin-vue-i18n/messages'
import {en, es} from "vuetify/locale";

export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  allowComposition: true,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  warnHtmlMessage: false,
  globalInjection: true,
  runtimeOnly: false,
  messages: {
    en: {
      ...messages!.en,
      "$vuetify": en
    },
    es: {
      ...messages!.es,
      "$vuetify": es
    }
  }
});
